export default [
  {
    title: '行业ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '行业名称',
    dataIndex: 'name',
    width: 200,
    key: 'name',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '首页图片',
    dataIndex: 'deviceConfig.homepagePhotoUrl',
    key: 'exSn',
    width: 200,
    scopedSlots: { customRender: 'homepagePhotoUrl' }
  },
  {
    title: '核验通过语音',
    dataIndex: 'deviceConfig.passVoice',
    key: 'state',
    width: 200,
  },
  {
    title: '核验失败语音',
    dataIndex: 'deviceConfig.notPassVoice',
    key: 'note',
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 180,
    scopedSlots: { customRender: 'action' }
  }
]
